// extracted by mini-css-extract-plugin
module.exports = {"box":"PersonalData_box__oImZf","entry":"PersonalData_entry__reeIN","label":"PersonalData_label__5bOmV"};